import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=ce5036b8&scoped=true&"
import script from "./Result.vue?vue&type=script&lang=ts&"
export * from "./Result.vue?vue&type=script&lang=ts&"
import style0 from "./Result.vue?vue&type=style&index=0&id=ce5036b8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5036b8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VChip,VIcon,VList,VListItem,VListItemAction,VListItemContent,VListItemSubtitle,VListItemTitle})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src567975772/src/search.myaileron.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce5036b8')) {
      api.createRecord('ce5036b8', component.options)
    } else {
      api.reload('ce5036b8', component.options)
    }
    module.hot.accept("./Result.vue?vue&type=template&id=ce5036b8&scoped=true&", function () {
      api.rerender('ce5036b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/search/Result.vue"
export default component.exports